module.exports = __webpack_public_path__ + "img/iwonder64_ua.6bf55606.webp";